import { useState } from 'react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { Article } from '../lib/types';
import { samples, SAMPLE_MESSAGE } from '../components/SampleDialog';
import { WorkspaceTicketState } from './useWorkspaceTicket';

export function useSampleWorkspace(state: WorkspaceTicketState, refresh: () => Promise<void>) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const loadSample = async () => {
    setBusy(true);
    try {
      const documents = await api<Article[]>('/kb');
      const titles = new Set(documents.map(document => document.title));
      for (const sample of samples) {
        if (!titles.has(sample.title)) await api('/kb', 'POST', sample);
      }
      state.setMessage(SAMPLE_MESSAGE);
      state.setTitle('Charged twice for my subscription');
      setOpen(false);
      await refresh();
      toast.success('Example loaded. Sample policies are labeled in your knowledge base.');
    } catch (error: any) { toast.error(error.message); }
    finally { setBusy(false); }
  };
  return {open, setOpen, busy, loadSample};
}